import React from 'react';
import { Link } from 'react-router-dom';

function DrugCard({ drug }) {
  return (
    <div className="card">
      <h3 style={{ marginBottom: '0.5rem', color: 'var(--text)' }}>
        💊 {drug.label || 'Unknown Drug'}
      </h3>
      
      {drug.rxcuis && drug.rxcuis.length > 0 && (
        <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: '1rem' }}>
          RxCUIs: {drug.rxcuis.join(', ')}
        </p>
      )}

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '0.5rem',
        marginBottom: '1rem'
      }}>
        {drug.counts && Object.entries(drug.counts).map(([type, count]) => (
          <div key={type} style={{
            fontSize: '0.875rem',
            color: 'var(--text-secondary)'
          }}>
            {type === 'SideEffect' && `⚠️ Side Effects: ${count}`}
            {type === 'DiseaseIndication' && `✅ Disease Indications: ${count}`}
            {type === 'PhenotypeIndication' && `✅ Phenotype Indications: ${count}`}
            {type === 'DrugIndication' && `💊 Drug Indications: ${count}`}
            {type === 'DiseaseContraindication' && `🚫 Disease Contraindications: ${count}`}
            {type === 'PhenotypeContraindication' && `🚫 Phenotype Contraindications: ${count}`}
            {type === 'DrugContraindication' && `🚫 Drug Contraindications: ${count}`}
          </div>
        ))}
      </div>

      <Link to={`/drug/${drug.id}`} className="btn btn-primary">
        View Details
      </Link>
    </div>
  );
}

export default DrugCard;
